import React, { useEffect } from "react";
import dayjs from "dayjs";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: 35,
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    listStyle: "none",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  }
}));

export default function ChipsArray(props) {
  const { filters, setFilters, placementSites } = props;
  const classes = useStyles();
  const [chipData, setChipData] = React.useState([]);

  useEffect(() => {
    const filterArray = [];

    const formatKey = (key) => {
      key = key.slice(0, 1).toUpperCase() + key.slice(1);
      if (
        key === "LeadTime" ||
        key === "ServingType" ||
        key === "LastModified"
      ) {
        key = key.split(/(?=[A-Z])/).join(" ");
        return key;
      } else {
        return key;
      }
    };

    const formatValue = (key, value) => {
      if (key === "site") {
        return placementSites[value].name;
      } else if (key === "lastModified") {
        const date = new Date(parseInt(value));
        return [
          ("0" + (date.getUTCMonth() + 1)).slice(-2),
          ("0" + date.getUTCDate()).slice(-2),
          ("0" + date.getUTCFullYear()).slice(-2)
        ].join("/");
      } else if (key === "start" || key === "end") {
        const d = dayjs(value);
        return d.format('MM/DD/YY')
      } else if (key === "compatibility") {
        let word = value.slice(0, 1) + value.slice(1).toLowerCase();
        return word.replace("_", "").replace("_", " ");
      } else {
        return value;
      }
    };

    for (let filter in filters) {
      if (filters[filter] !== "All") {
        filterArray.push({
          key: filter,
          label: formatKey(filter) + ": " + formatValue(filter, filters[filter])
        });
      }
    }
    setChipData(filterArray);
  }, [filters, placementSites]);

  const handleDelete = (chipToDelete) => () => {
    setFilters({
      ...filters,
      [chipToDelete.key]: "All"
    });
  };

  return (
    <div className={classes.root}>
      {chipData.map((data) => {
        return (
          <li key={data.key}>
            <Chip
              label={data.label}
              onDelete={handleDelete(data)}
              className={classes.chip}
            />
          </li>
        );
      })}
    </div>
  );
}
